module.exports = __webpack_public_path__ + "static/media/638.f23cb9be.webp";